import { createReducer } from "@reduxjs/toolkit";
import {
    deletePoliciesSuccess,
  getPoliciesDocumentListSuccess,
  getPoliciesListSuccess,
  LoadingData,
  loadingList,
  savePoliciesListSuccess,
} from "./policiesActions";
import { deleteReturnSuccess } from "../returns/returnActions";

export interface IPoliciesState {
  policiesList: Array<any>;
  dataCount: number;
  isLoading: boolean;
  policiesDocumentList : any[];
}

const initialState: IPoliciesState = {
  policiesList: [],
  dataCount: 0,
  isLoading: false,
  policiesDocumentList : []
};

export const policiesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(LoadingData, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })
    .addCase(getPoliciesListSuccess, (state, action) => {
      state = {
        ...state,
        policiesList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })

    .addCase(savePoliciesListSuccess, (state, action) => {
      state = {
        ...state,
        policiesList    : action.payload,
      };
      return state;
    })

    .addCase(loadingList, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })

    .addCase(deletePoliciesSuccess, (state, action) => {
      const filteredList = state
      .policiesList.filter(
        (item) => !action.payload.includes(item.id)
      );
      return {
        ...state,
        policiesList: filteredList,
      };
    })
    .addCase(getPoliciesDocumentListSuccess, (state, action) => {
      state = {
        ...state,
        policiesDocumentList: action.payload?.data,
      };
      return state;
    });

});


